
<template>
  <el-container class="pagination-list doing-task">
    <el-main>
      <!--XXX: 该页面不建议进行维护, 当前页面会列出所有人发布的流程的信息, 能查看该页面的账号拥有类似超管的权限, 不安全-->
      <div class="content">
        <el-form :inline="true" :model="process" ref="process" @keyup.enter.native="search">
          <el-form-item prop="processState" label="流程状态">
            <el-select v-model="process.processState" @change="search" placeholder="请选择流程状态" clearable>
              <el-option
                v-for="option in processStates"
                :key="option.key"
                :value="option.key"
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--64期晟融流程类型需求-1544-->
          <el-form-item label="流程分类" v-if="tenantId==='16DB9E8F-4B50-003D-9ED7-32C247B72173'">
            <el-select placeholder="请选择流程分类"  v-model="selectedProcess" value-key="name" @change="getTableData" filterable clearable >
              <el-option v-for="item in selectedProcessList" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="keyword">
            <el-input v-model="process.keyword" placeholder="请输入关键字" clearable/>
          </el-form-item>
          <!--操作按钮-->
          <el-form-item class="process-operation-buttons">
            <el-button @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table class="table-list" :data="items" v-loading="loading" height="100%">
          <el-table-column property="processTitle" label="流程信息" align="center" show-overflow-tooltip></el-table-column>
          <!--64期晟融流程类型需求-1544-->
          <el-table-column property="name" label="流程类型" align="center" v-if="tenantId==='16DB9E8F-4B50-003D-9ED7-32C247B72173'"></el-table-column>
          <el-table-column property="startedTime" label="开始时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column property="endTime" label="结束时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column property="taskName" label="当前节点" align="center"></el-table-column>
          <el-table-column property="taskAssignee" label="当前处理人" align="center"></el-table-column>
          <el-table-column property="status" label="流程状态" align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="stateView(scope.row)">状态</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total,sizes, prev, pager, next,jumper "
            :total="pagination.total"
          ></el-pagination>
        </el-footer>
        <approval-comment
          :dialogVisible="commentVisible"
          :approvalCommentHistory="approvalCommentHistory"
          :currentNodeId="currentNodeId"
          @close="commentVisible=false"
          @viewState="viewTask"></approval-comment>
      </div>
    </el-main>
   <dialog-form-runtime :formRuntimeDialog="formRuntimeDialog"  @openDialog="openDialog"></dialog-form-runtime>
  </el-container>
</template>

<script>
import ProcessStateView from '@/components/process/runtime/process-stateView.vue'
import ApprovalComment from '@/components/process/runtime/approval-comment'
import CookieOperation from '@/plugins/cookie'
import {processtMixin, processViewMixin} from '@/components/process/runtime/mixin'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
import moment from 'moment'
export default {
  mixins: [processtMixin, processViewMixin],
  name: 'ProcessInstanceListSystem',
  data () {
    return {
      process: {
        processState: '',
        keyword: ''
      },
      processStates: [{
        text: '全部'
      }, {
        key: '1',
        text: '进行中'
      }, {
        key: '2',
        text: '已完成'
      }, {
        key: '3',
        text: '已终止'
      }, {
        key: '4',
        text: '已作废'
      }],
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      instanceId: '',
      filters: {},
      tenantId: '',
      selectedProcess: '',
      selectedProcessList: []
    }
  },
  components: {
    ApprovalComment,
    ProcessStateView,
    DialogFormRuntime
  },
  watch: {
    'pagination.currentPage' (val) {
      this.getTableData()
    },
    'pagination.pageSize' (val) {
      this.getTableData()
    }
  },
  async created () {
    this.tenantId = CookieOperation.get('tenantId')
    if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
      await this.loadSelectedProcess()
    }
    this.getTableData()
  },
  methods: {
    // 获取可选择的流程分类名称
    loadSelectedProcess () {
      this.pagination.currentPage = 1
      // 晟融单独接口
      if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
        this.$axios.get('/process-api/processes/categorys4Shengr').then(res => {
          this.selectedProcessList = res.data
        })
      } else {
        this.$axios.get('/process-api/processes/categorys').then(res => {
          this.selectedProcessList = res.data
        })
      }
    },
    search () {
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.process.keyword,
        'processState': this.process.processState
      }
      this.getTableData()
    },
    formatDate (row, column) {
      var data = row[column.property]
      if ((column.property === 'startedTime' || column.property === 'endTime') && data) {
        return moment(data).format('YYYY-MM-DD HH:mm')
      }
      return data
    },
    getTableData () {
      this.loading = true
      let page = this.pagination
      if (this.selectedProcess === '') {
        this.filters = {
          'keyword': this.process.keyword,
          'processState': this.process.processState
        }
      } else {
        this.filters = {
          'keyword': this.process.keyword,
          'processState': this.process.processState,
          'name': this.selectedProcess
        }
      }
      let params = {
        'index': page.currentPage,
        'size': page.pageSize,
        'filters': this.filters
      }
      this.$axios.get('/process-api/runtime/instances/count', {params})
        .then((res) => {
          this.pagination.total = res.data
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
          }
        })
      this.$axios.get('/process-api/runtime/getInstances', {params})
        .then((res) => {
          this.items = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    viewTask (row, type) {
      this.showOpenDialog = true
      this.commentVisible = false
      this.$router.push({ name: 'process-view', params: { instanceId: this.approvalInstanceId, currentNodeId: row } })
    },
    openDialog () {
      if (this.showOpenDialog) {
        this.commentVisible = true
        this.showOpenDialog = false
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss'
</style>



// WEBPACK FOOTER //
// src/components/system/system/process-instanceList-system.vue